import _ from 'lodash';
import { apiSearch } from '../utility';

export const searchCustomers = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.customer.search',
			base: 'quickbooksCustomer',
			//listName : 'quickbooksCustomer',
			params: {},
			dispatch,
			callback,
		});
	};
};

export const searchVendors = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.vendor.search',
			base: 'quickbooksVendor',
			params: {},
			dispatch,
			callback,
		});
	};
};

export const searchClasses = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.class.search',
			base: 'quickbooksClass',
			params: {},
			dispatch,
			callback,
		});
	};
};

export const searchAccounts = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.account.search',
			base: 'quickbooksAccount',
			params: {},
			dispatch,
			callback,
		});
	};
};

export const searchItems = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.item.search',
			base: 'quickbooksItem',
			params: {},
			dispatch,
			callback,
		});
	};
};

export const searchTerms = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			method: 'quickbooks.term.search',
			base: 'quickbooksTerm',
			//listName : 'quickbooksCustomer',
			params: {},
			dispatch,
			callback,
		});
	};
};

/*
export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `quickbooks.customer.get`,
			base : 'quickbooksCustomer',
			//listName : 'quickbooksCustomer',
			//idName : 'Id',
			params,
			dispatch,
			callback,
		});
	};
};
*/
